import { motion } from "framer-motion";
import { XMarkIcon } from "@heroicons/react/24/solid";

export default function CloseButton({
  onRequestClose,
}: {
  onRequestClose: () => void;
}) {
  return (
    <motion.button
      className="absolute left-4 top-4 h-10 w-10"
      onClick={(e) => {
        e.stopPropagation();

        onRequestClose();
      }}
      whileHover={{
        rotate: 360,
        scale: 1.1,
      }}
      whileTap={{ scale: 0.75 }}
      variants={{
        closed: { opacity: 0, y: -1, transition: { duration: 0.3 } },
        open: { opacity: 1, y: 0, transition: { duration: 0.3 } },
      }}
    >
      <XMarkIcon />
    </motion.button>
  );
}
